import React from "react";
import LpCta from "./LpCta";
import { CONSULTA_CARDS } from "./lpData";

const LpConsulta = () => (
  <section className="section-pad bg-white" data-testid="lp-consulta">
    <div className="aevos-container">
      <div className="max-w-3xl">
        <h2 className="font-display font-bold text-3xl md:text-5xl leading-[1.08]">
          Entenda o que precisa ser considerado no seu emagrecimento
        </h2>
        <p className="mt-5 text-[#333333] text-base md:text-lg leading-relaxed">
          A consulta inicial reúne as informações necessárias para definir prioridades e construir
          uma estratégia compatível com seu momento de vida.
        </p>
      </div>

      <div className="mt-12 grid md:grid-cols-2 gap-5">
        {CONSULTA_CARDS.map((card, i) => (
          <article key={card.title} className="aevos-card p-7" data-testid={`lp-consulta-card-${i}`}>
            <span className="font-display font-bold !text-[#00C4FF] text-3xl leading-none">
              {String(i + 1).padStart(2, "0")}
            </span>
            <h3 className="font-display font-semibold text-lg md:text-xl mt-4">{card.title}</h3>
            <p className="mt-3 text-[#333333] text-sm md:text-base leading-relaxed">{card.text}</p>
          </article>
        ))}
      </div>

      <div className="mt-12 bg-black text-white p-8 md:p-10 flex flex-col md:flex-row md:items-center md:justify-between gap-6" data-testid="lp-consulta-price">
        <div>
          <p className="aevos-eyebrow">Consulta Médica Individualizada</p>
          <p className="font-display font-bold !text-white text-3xl md:text-4xl mt-2">
            Investimento: <span className="text-[#00C4FF]">R$ 600</span>
          </p>
        </div>
        <LpCta location="consulta">Quero agendar minha avaliação</LpCta>
      </div>
    </div>
  </section>
);

export default LpConsulta;
